<div class="tracking-page-search-preview-container">
  <pdq-card variant="popover" color="white">
    <div class="card">
      <div class="card__header">
        <pdq-heading element="h5">Preview</pdq-heading>
      </div>
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <div class="tracking-page-search-preview">
          <div [style.text-align]="titleAlignment" [style.margin-bottom]="'10px'">
            <h2>{{ title }}</h2>
          </div>

          @if (verifyByTrackingOrOrderNumber) {
            <div class="container__head">
              <div class="content">
                <div [style.font-weight]="400">{{ inputPlaceholder }}</div>
              </div>
            </div>
          }
          @if (verificationStrategy === VerificationStrategy.EMAIL_ONLY) {
            <div class="container__head">
              <div class="content">
                <div [style.font-weight]="400">{{ emailPlaceholder }}</div>
              </div>
            </div>
          }
          @if (verificationStrategy === VerificationStrategy.PHONE_ONLY) {
            <div class="container__head">
              <div class="content">
                <div [style.font-weight]="400">{{ phonePlaceholder }}</div>
              </div>
            </div>
          }
          @if (
            verificationStrategy === VerificationStrategy.EMAIL_AND_PHONE ||
            verificationStrategy === VerificationStrategy.EMAIL_OR_PHONE
          ) {
            <div class="container__head">
              <div class="content">
                <div [style.font-weight]="400">{{ emailPlaceholder }}</div>
              </div>
            </div>
            <div class="container__head">
              <div class="content">
                <div [style.font-weight]="400">{{ phonePlaceholder }}</div>
              </div>
            </div>
          }
          @if (buttonText) {
            <div class="container__head" [style.background-color]="accentColor">
              <div class="content">
                <div [style.font-weight]="500" [style.color]="'#FFFFFF'" [style.text-align]="'center'">
                  {{ buttonText }}
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </pdq-card>
</div>
